import React, { useContext, useEffect } from 'react';
import ScoreCommitteeDashboardV2 from '../components/dashboard/ScoreCommitteeDashboardV2';
import SnakeOverlay from '../components/EasterEgg/SnakeOverlay';

import { UserDataContext } from '../firebase/UserDataContext';
import { GlobalSettingsContext } from '../firebase/GlobalSettingsContext';
import JudgeDashboardNew from '../components/dashboard/JudgeDashboardNew';
import TeamDashboardNew from '../components/dashboard/TeamDashboardNew';
import { ROLES } from '../components/misc/Utils';
import { useNavigate } from 'react-router-dom';
import * as routes from '../routes/routes';
import LoadingSkeleton from '../components/misc/LoadingSkeleton';

const DashboardRouter = () => {
    const navigate = useNavigate()
    const { defaultSelectedCompetition, user } = useContext(UserDataContext)
    const { globalSettings } = useContext(GlobalSettingsContext)

    useEffect(() => {
        if (Object.keys(user).length > 0 && !user.loggedIn) {
            navigate(routes.SIGN_IN)
        }
    }, [user, navigate])

    let content = null;

    switch (true) {
        case (Object.keys(globalSettings).length == 0 || Object.keys(user).length == 0):
            content = <LoadingSkeleton />
            break;
        case [ROLES.ADMIN, ROLES.SCORECOMMITTEE].includes(user.role):
            content = <ScoreCommitteeDashboardV2 competition={globalSettings.competitions[defaultSelectedCompetition]} />
            break;
        case ROLES.JUDGE === user.role:
            content = <JudgeDashboardNew />
            break;
        case ROLES.TEAM === user.role:
            content = <TeamDashboardNew />
            break;
        default:
            content = <div>Unable to route you to where you expected to go. Please contact an Administrator</div>
    }

    return (
        <>
            <SnakeOverlay />
            {content}
        </>
    )
}

export default DashboardRouter;
